export const resources = {
  resourcesFolderInfoText: 'Soubor(y)',
  resourcesItemInfoLastUpdText: 'Aktualizováno',
  resourcesItemInfoUploadedText: 'Nahráno',
  resourcesSearchInputText: 'Hledat',
  resourcesUserActionSheetOptionTitle: 'Kopírovat odkaz',
  resourcesActionCopiedAlertText: 'Odkaz zkopírován!',
  resourcesOwnersCurtainEditOptionText: 'Upravit název',
  resourcesOwnersCurtainDeleteOptionText: 'Smazat',
  resourcesOwnerCurtainHideOptionText: 'Skrýt (Neaktivní)',
  resourcesEditPopupTitle: 'Upravit název',
  resourcesEditPopupResetButtonTitle: 'Resetovat',
  resourcesEditPopupApplyButtonTitle: 'Použít',
  resourcesItemEditedAlertText: 'Položka byla úspěšně aktualizována!',
  resourcesHidePopupTitle: 'Skrýt',
  resourcesHidePopupText: 'Skrýt tuto položku?',
  resourcesHidePopupCancelButtonTitle: 'Zrušit',
  resourcesHidePopupConfirmButtonTitle: 'Potvrdit',
  resourcesDeletePopupTitle: 'Smazat',
  resourcesDeletePopupText: 'Smazat tuto položku?',
  resourcesDeletePopupCancelButtonTitle: 'Zrušit',
  resourcesDeletePopupConfirmButtonTitle: 'Potvrdit',
  resourcesItemDeletedAlertText: 'Položka byla úspěšně smazána!',
  resourceDetailsLinkText: 'Toto je externí URL adresa a bude otevřena v novém okně. Otevřít?',
  resourceDetailsLinkOpenButtonTitle: 'Otevřít',
  resourceDetailsLinkOpenAgainButtonTitle: 'Otevřít znovu',
  resourceDetailsLinkCopyURLButtonTitle: 'Kopírovat cílovou URL',
  resourceDetailsLinkCopiedURLAlertText: 'URL adresa zkopírována!',
  resurceDetailsLinkCurtainOptionCopyText: 'Kopírovat odkaz',
  resourceDetailsFileInfoLastUpdText: 'Aktualizováno',
  resourceDetailsFileInfoUploadText: 'Nahráno',
  resourceDetailsFileSaveButtonTitle: 'Otevřít',
  resourceDetailsFileCopyButtonTitle: 'Kopírovat odkaz',
  resourcesOwnersCurtainCopyOptionText: 'Kopírovat odkaz',
  resourceDetailsFileLoadingText: 'Stahování...',
  resourceDetailsImageCurtainCopyOptionText: 'Kopírovat odkaz',
  resourceDetailsImageCurtainDownloadOptionText: 'Stáhnout',
  resourceFolder: 'Složka',
  resourceAdded: 'Přidáno'
}
